// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1_4GO","row":"ProcedureTreatmentSummary_row__1WnSO"};